import {
  apiFetch,
  apiFetchJson,
  apiFetchWithoutBearer,
  parseApiResponse,
} from '../../config/apiBase';

const APPLY = '/api/survey-offline/apply';

/**
 * 비패널 신청 시 Bearer 미전송 — 3.0 세션 로그아웃 후 게스트 신청과 동일하게 panelId 미인식.
 * @param {string} path
 * @param {RequestInit} init
 * @param {boolean} [asGuest]
 */
async function applyFetchJson(path, init, asGuest = false) {
  if (asGuest) {
    const res = await apiFetchWithoutBearer(path, {
      ...init,
      credentials: 'omit',
    });
    return parseApiResponse(res);
  }
  return apiFetchJson(path, init);
}

/**
 * 좌담회 신청 API (3.0 result 맵 → ApiResponse.data).
 * @returns {Promise<{ result?: string, srvReqNo?: string, confirmPerform?: object, qusetAnswerList?: array, ... }>}
 */
export async function postSurveyOfflineApplyCheckInvite(body, asGuest = false) {
  return applyFetchJson(
    `${APPLY}/check-invite`,
    {
      method: 'POST',
      body: JSON.stringify(body ?? {}),
    },
    asGuest,
  );
}

export async function postSurveyOfflineApplyMyInfo() {
  const res = await apiFetch(`${APPLY}/my-info`, { method: 'POST', body: '{}' });
  if (res.status === 404) return null;
  if (!res.ok) return null;
  return parseApiResponse(res);
}

export async function postSurveyOfflineApplyPreAnswersList(srvNo, srvReqNo, asGuest = false) {
  return applyFetchJson(
    `${APPLY}/pre-answers/list`,
    {
      method: 'POST',
      body: JSON.stringify({ srvNo, srvReqNo }),
    },
    asGuest,
  );
}

export async function postSurveyOfflineApplyPreAnswers(rows, asGuest = false) {
  return applyFetchJson(
    `${APPLY}/pre-answers`,
    {
      method: 'POST',
      body: JSON.stringify(rows ?? []),
    },
    asGuest,
  );
}

export async function postSurveyOfflineApplyStart(body, asGuest = false) {
  return applyFetchJson(
    `${APPLY}/start`,
    {
      method: 'POST',
      body: JSON.stringify(body ?? {}),
    },
    asGuest,
  );
}

export async function postSurveyOfflineApplyConfirmData(srvNo, srvReqNo, asGuest = false) {
  return applyFetchJson(
    `${APPLY}/confirm-data`,
    {
      method: 'POST',
      body: JSON.stringify({ srvNo, srvReqNo }),
    },
    asGuest,
  );
}

export async function postSurveyOfflineApplyConfirmFinal(srvNo, srvReqNo, asGuest = false) {
  return applyFetchJson(
    `${APPLY}/confirm-final`,
    {
      method: 'POST',
      body: JSON.stringify({ srvNo, srvReqNo }),
    },
    asGuest,
  );
}

export async function postSurveyOfflineApplyLegacySubmit(body, asGuest = false) {
  return applyFetchJson(
    `${APPLY}/legacy-submit`,
    {
      method: 'POST',
      body: JSON.stringify(body ?? {}),
    },
    asGuest,
  );
}
